/*
 *
 * Change Expired Password
 *
 */

import "./styles.scss";

import { API, Endpoints } from "utils/api";
import { Input, notification } from "antd";

import { Footer } from "screens";
import { Helmet } from "react-helmet";
import { Icons } from "components";
import Password from "components/Password";
import React from "react";
import Strings from "utils/strings";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { setLoader } from "store/actions";

export class ChangeExpiredPassword extends React.Component<any, any> {
	constructor(props: any) {
		super(props);

		const params = new URLSearchParams(props.location?.search);

		this.state = {
			email: params.get("email") || "",
			currentPassword: "",
			newPassword: "",
			showCurrentPassword: false,
			showNewPassword: false,
			isPasswordValid: false,
			isMobile: window.innerWidth <= 768
		};

		this.handleResize = this.handleResize.bind(this);
		window.addEventListener("resize", this.handleResize);
	}

	componentDidMount() {
		this.handleResize();
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.handleResize);
	}

	handleResize() {
		this.setState({ isMobile: window.innerWidth <= 768 });
	}

	async changePassword() {
		const { email, currentPassword, newPassword, isPasswordValid: valid } = this.state;
		const { dispatch } = this.props;

		if (!valid) {
			notification.error({
				message: Strings.authentication.header,
				description: Strings.authentication.passwordinfo,
				placement: "bottomRight",
				duration: 5
			});
			return;
		}

		dispatch(setLoader(true));

		let response: any;
		try {
			response = await API.post({
				url: Endpoints.uriUsersExpiredPassword(),
				data: {
					email,
					currentPassword,
					newPassword
				}
			});

			if (response.ok) {
				notification.success({
					message: Strings.authentication.header,
					description: Strings.authentication.passwordChangedSuccess,
					placement: "bottomRight",
					duration: 5
				});
				dispatch(push("/login"));
			} else {
				notification.error({
					message: Strings.authentication.header,
					description: response?.data?.message || Strings.serverErrors.invalidCredentials,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.authentication.header,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	render() {
		const { email, currentPassword, showCurrentPassword, newPassword, showNewPassword, isPasswordValid: valid } = this.state;
		const { dispatch, mobile } = this.props;

		return (
			<React.Fragment>
				<Helmet>
					<title>{Strings.authentication.changeExpiredPassword} | Team24</title>
					<meta name="description" content="Change Expired Password" />
				</Helmet>
				<div className="ChangeExpiredPasswordContent">
					<div className="ChangeExpiredPasswordWrapper">
						<div className="LoginBox">
							<div className="LoginWelcome" />
							<div className="LoginWrapper">
								<div className="LoginBackground" />
								<div className="LoginForm">
									<h3>{Strings.authentication.passwordExpired}</h3>
									<form
										onSubmit={(e: any) => {
											e.preventDefault();
											this.changePassword();
										}}
									>
										<Input
											placeholder={Strings.authentication.currentPassword}
											className="LoginInputClass"
											value={currentPassword}
											type={showCurrentPassword ? "text" : "password"}
											required
											prefix={<Icons.Lock />}
											suffix={
												<button
													onClick={(e: any) => {
														e.preventDefault();
														e.stopPropagation();
														this.setState((prevState: any) => ({
															showCurrentPassword: !prevState.showCurrentPassword
														}));
													}}
													type="button"
													className="LoginInputPasswordViewer"
												>
													<Icons.Eye />
												</button>
											}
											onChange={(e: any) => this.setState({ currentPassword: e.target.value })}
										/>
										<Password
											className="LoginInputClass"
											password={newPassword}
											showPassword={showNewPassword}
											placeholder={Strings.authentication.newPasswordPlaceholder}
											onPasswordChange={(pwd: string, isValid: boolean) => {
												this.setState({
													newPassword: pwd,
													isPasswordValid: isValid
												});
											}}
											onShowPasswordChange={(value: boolean) =>
												this.setState({ showNewPassword: value })
											}
										/>
										<div className="LoginOptions">
											<a
												href="/login"
												onClick={(e: any) => {
													e.preventDefault();
													dispatch(push("/login"));
												}}
												className="LoginOptionLink"
											>
												{Strings.authentication.goBackToLogin}
											</a>
										</div>
										<button
											type="submit"
											className="LoginButtonClass"
											disabled={!currentPassword || !valid}
										>
											{Strings.authentication.changePassword}
										</button>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
				{mobile && <Footer />}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({
	mobile: state.mobile
});

export default connect(mapStateToProps)(ChangeExpiredPassword);
